export const FETCH_CUSTOMER_TREATMENT_INCOME_REQUEST = "FETCH_CUSTOMER_TREATMENT_INCOME_REQUEST";
export const FETCH_CUSTOMER_TREATMENT_INCOME_SUCCESS = "FETCH_CUSTOMER_TREATMENT_INCOME_SUCCESS";
export const FETCH_CUSTOMER_TREATMENT_INCOME_FAILURE = "FETCH_CUSTOMER_TREATMENT_INCOME_FAILURE";
